export default "__VITE_ASSET__0a1e3592__"